import { Capacitor } from '@capacitor/core';
import { DeviceInformation } from '../../../capacitor_plugins/deviceInformation';
import { CAPACITOR_DEVICE_INFORMATION_PLUGIN } from '../../../capacitor_plugins/pluginConstants';
import globalLogger from '../../logger';
import { isPlatformAndroid } from '../../platform/utils/platformDetailsUtils';
import platformSingleton from '../../platform/platformSingleton';

const logger = globalLogger.createChannel('mobile.navigationBarHeight');

/**
 * Adds the navigation bar height to the root element
 * This is used to create a bar under **Androids** navigation buttons when in 'light' mode
 * to prevent the buttons from being washed out but the bottom toolbar.
 */
export const addNavigationBarValues = async () => {
    if (!Capacitor.isPluginAvailable(CAPACITOR_DEVICE_INFORMATION_PLUGIN)) return;
    if (!isPlatformAndroid(platformSingleton)) return;

    try {
        const { height = 0 } = await DeviceInformation.getNavBarHeight();
        document.body.style.setProperty('--nav-bar-height', `${height}px`);
    } catch (error) {
        logger.error('Failed to add navigation bar values', error);
    }
};
